import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { withStyles } from "@material-ui/styles";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import ScrollTop from "./ScrollTop";

function PrivacyPolicy({ classes }) {
  return (
    <>
      <Grid
        container
        style={{
          minHeight: "100vh",
          width: "100%",
          padding: "15px 40px",
          margin: "0 auto",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            textAlign: "justify",
          }}
        >
          <Box mt={4} mb={2}>
            <Typography
              variant="h4"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Privacy Policy
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            Please read this privacy policy carefully. By accessing or using the
            website, you agree to be bound by the terms described herein and all
            the terms incorporated by reference. If you do not agree to all of
            these terms, do not use the website. Your privacy is of utmost
            importance to us and protection of your information is a key
            commitment for us. We are governed by the provisions of applicable
            laws to maintain the privacy of your information.
          </Typography>
          <Box>
            <Typography
              variant="h5"
              style={{
                marginBottom: "16px",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Content & Purpose of the Privacy Policy
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              This privacy policy (“Privacy Policy”) applies to your use of the
              domain name www.necessarydevil.com, an internet based portal, and
              a mobile application, owned and operated by Interface Infosoft
              Solutions Private Limited, a company duly incorporated under the
              provisions of the Companies Act, 2013 (hereinafter, referred to as
              “NecessaryDevil” or “Interface Infosoft Solutions. P. Ltd” or “We”
              or “Our” or “Us” or “Company”). The domain name and the mobile
              application are collectively referred to as “Website”.
            </Typography>
          </Box>
          <Typography
            variant="h5"
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            Definitions:
          </Typography>
          <Typography
            variant="h5"
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            NecessaryDevil:
          </Typography>
          <Typography className={classes.greyText}>
            NecessaryDevil is a cloud-based technology platform that conducts
            endurance events. The scope of NecessaryDevil is (& not limited to)
          </Typography>
          <ul
            style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
            className={classes.greyText}
          >
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Manage registrations for the event
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Execution of the event
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Send results and digital goods to the participants
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Send digital goods to the host
              </Typography>
            </li>
          </ul>

          <Box sx={{ marginBottom: "16px" }}>
            <Box mb={2}>
              <Typography variant="body2" className={classes.greyText}>
                Interface Infosoft Solutions. P. Ltd: Interface Infosoft
                Solutions Private Limited, a company duly incorporated under the
                provisions of the Companies Act, 2013 solely owns & operates the
                platform NecessaryDevil.
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body2" className={classes.greyText}>
                Event Organizer/Organizer: Are the entities which conduct
                physical/virtual events on NecessaryDevil on payable or free
                basis as per agreement between them & Interface Infosoft
                Solutions. P. Ltd.
              </Typography>
            </Box>
            <Typography variant="body2" className={classes.greyText}>
              Participants: Participants are the entities which are coordinated
              by the organizers to participate in virtual endurance events.
              There is no agreement whatsoever between Participants & Interface
              Solutions. P. Ltd or NecessaryDevil.
            </Typography>
          </Box>

          <Box mb={2}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Information Collection
            </Typography>
          </Box>
          <Box className={classes.greyText}>
            <Typography variant="body2" paragraph>
              We collect information during registration, use of the services
              site, communicating with site members, admin, using content,
              content upload to our site. We also receive information about your
              IP address, cookies and pages you visited. We use your information
              held about you in the following way:
            </Typography>

            <ol style={{ paddingLeft: "1.5rem", marginTop: 0 }}>
              <li>
                <Typography variant="body2">
                  To ensure that content from our site is presented in the most
                  effective manner for you and for your computer; and facilitate
                  transactions with you.
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  To carry out our obligations arising from any contracts
                  entered into between you and us; and comply with applicable
                  law if any in this regard.
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  To provide you with information that you request from us or
                  which we feel may interest you, where you have consented to be
                  contacted for such purposes.
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  To notify you about changes to our products and services and
                  also to carry out further research and analysis for
                  monitoring/reviewing/improving/providing our products and
                  services and selection of offers, promotions and marketing
                  campaigns.
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  To verify your identity for us to provide products/services to
                  you and to respond to your queries or feedback submitted by
                  you.
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  To carry credit checks, screenings or due diligence checks as
                  lawfully required by us and undertake audit, record keeping,
                  reporting and develop risk management models.
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  To provide your personal information to our affiliates/other
                  trusted businesses/ persons/service providers engaged by us,
                  or institutions that we partner with, to assist us with
                  providing you with products/services to better serve your
                  needs and interests, based on your instructions and in
                  compliance with our privacy policy and any other appropriate
                  confidentiality and security measures.
                </Typography>
              </li>
            </ol>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Information Sharing
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            We will always obtain your prior specific consent before we share or
            disclose your personally identifiable information to any partner,
            and user. We are also accountable to disclose user information and
            the contents of the accounts to the local law enforcement
            authorities under specifically defined circumstances. In case
            Necessary Devil service gets merged or acquired, we will be
            informing on the website about such developments.
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            In case your profile is public, or your details are in public domain
            in our site, you will receive unsolicited messages from users in
            necessarydevil.com and from external sources.
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            When you have opted for receiving related information, we will use
            your information to show you relevant advertisements, contents,
            events from us and our partners. Access to your name, email address
            and private details is restricted to our employees who need to know
            such information in connection with our services and are bound by
            confidentiality obligations.
          </Typography>

          {/* Existing Information Sharing section ends here */}

          <Box style={{ marginBottom: "16px", marginTop: "16px" }}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Cookies
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            A “cookie” is a small piece of text file/ information stored by a
            web server on a web browser/ your device about your visit on our
            online platforms so it can be later read back from that browser.
            Cookies allow us to recognize a specific device in order to
            personalize and optimize your experience.
          </Typography>

          <Box
            style={{
              marginBottom: "16px",
              marginTop: "16px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Google
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            Third party vendors, including Google, use cookies to serve ads
            based on a user’s prior visits to your website or other websites.
            Google’s use of advertising cookies enables it and its partners to
            serve ads to your users based on their visit to your sites and/or
            other sites on the Internet. Users may opt out of personalized
            advertising by visiting Ads Settings.
          </Typography>

          {/* Section: IP Address */}
          <Box
            style={{
              marginBottom: "16px",
              marginTop: "16px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <Typography variant="h5" gutterBottom>
              IP Address
            </Typography>
          </Box>

          <Typography variant="body2" className={classes.greyText}>
            When you visit necessarydevil.com, we receive the Internet protocol
            (IP) address of your computer, operating system information, browser
            information and name of your ISP. This information is used to
            improve our service offerings. We are also legally accountable to
            pass the same information to legal authorities when requested. We
            also use advanced web analytics, which provides information such as
            the URL of the site from which you came and the site to which you
            are going.
          </Typography>

          {/* Section: How Safe is your information */}
          <Typography variant="body2" className={classes.greyText}>
            How Safe is Your Information?
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            We adopt appropriate data collection, storage and processing
            practices and security measures, as well as physical security
            measures to protect against unauthorized access, alteration,
            disclosure or destruction of your Personal Information, username,
            password, transaction information and data stored in your account.
            While we try our best to provide security that is commensurate with
            the industry standards, because of the inherent vulnerabilities of
            the internet, we cannot ensure or warrant complete security of all
            information that is being transmitted to us by you.
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            Neither the Event Organizer, nor NecessaryDevil is responsible for
            breach of data due to inherent vulnerabilities of the internet.
          </Typography>

          {/* Section: Links to Third-Party Advertisements */}
          <Box
            style={{
              marginBottom: "16px",
              marginTop: "16px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Links to Third-Party Advertisements
            </Typography>
          </Box>

          <ol style={{ paddingLeft: "1.5rem", marginTop: 0 }}>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                The links to third-party advertisements, third party websites or
                any third party electronic communication services (referred to
                as “Third-Party Links”) may be provided on the Website which are
                operated by third parties and are not controlled by, or
                affiliated to, or associated with NecessaryDevil unless
                expressly specified on the Website.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                If you access any such Third-Party Links, we request you review
                the website’s privacy policy. We are not responsible for the
                policies or practices of Third-Party Links.
              </Typography>
            </li>
          </ol>

          {/* Section: Notification of Changes */}
          <Box
            style={{
              marginBottom: "16px",
              marginTop: "16px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Notification of Changes
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            When there are significant changes to the privacy policy, the same
            will be posted on our websites in order to keep you informed of any
            changes in nature of information collected, manner of collection,
            use and sharing of information.
          </Typography>

          {/* Section: Conflict Between Privacy Policy & Terms of Service */}
          <Box style={{ marginBottom: "16px", marginTop: "16px" }}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Conflict Between Privacy Policy & Terms of Service
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            At any time, when there is a conflict between the terms of service
            and the privacy policy, the Terms of Service shall prevail. We don’t
            provide service to children under age 16, therefore we don’t collect
            their information and privacy policy makes no provision for
            children’s use of the site.
          </Typography>

          {/* Section: Information Policy */}
          <Box style={{ marginTop: "16px", marginBottom: "16px" }}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Information Policy
            </Typography>
          </Box>

          <ol style={{ paddingLeft: "1.5rem", marginTop: 0 }}>
            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>Information collected from all users:</strong>
                <Typography variant="body2" className={classes.greyText}>
                  For all Users, we collect Personal Data when you voluntarily
                  provide such information to the Services, such as when you
                  register for access to the Services, contact us with
                  inquiries, respond to one of our surveys or browse or use
                  certain parts of the Services. The Personal Data we may
                  collect includes without limitation your name, address, email
                  address and any other information that you choose to provide
                  and/or that enables Users to be personally identified.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>Information we automatically collect:</strong>
                <Typography variant="body2" className={classes.greyText}>
                  We also automatically collect certain technical data that is
                  sent to us from the computer, mobile device and/or browser
                  through which you access the Services (“Automatic Data”).
                  Automatic Data, includes without limitation, a unique
                  identifier associated with your access device and/or browser
                  (including, for example, your Internet Protocol (IP) address)
                  characteristics about your access device and/or browser,
                  statistics on your activities on the Services, information
                  about how you came to the Services and data collected through
                  Cookies, Pixel Tags, Local Shared Objects, Web Storage and
                  other similar technologies. You can find out more information
                  about how we use Cookies and other similar tracking
                  technologies in our Cookie Statement. When you register for
                  the Services or otherwise submit Personal Data to us, we may
                  associate other Non-Personal Data (including Non-Personal Data
                  we collect from third parties) with your Personal Data. At
                  such instance, we will treat any such combined data as your
                  Personal Data until such time as it can no longer be
                  associated with you or used to identify.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>Information collected from organizers:</strong>
                <Typography variant="body2" className={classes.greyText}>
                  If you are an Organizer we will collect additional Personal
                  Data from you. Information you provide to us: In some cases,
                  we may collect your credit card information (e.g., your credit
                  card number and expiration date, billing address, etc.), some
                  of which may constitute Personal Data, to secure certain
                  payments. In addition, if you use our payment processing
                  services, we will collect financial information from you
                  (e.g., your bank account information or an address to send
                  checks) as necessary to facilitate payments and information
                  required for tax purposes (e.g., your taxpayer identification
                  number). Information we obtain from other sources: We may also
                  collect or receive Personal Data including your name, email
                  address and other contact information from third party
                  sources, such as third-party websites and marketing partners,
                  your bank, our payment processing partners and credit
                  reporting agencies.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>Information collected from users:</strong>
                <Typography variant="body2" className={classes.greyText}>
                  If you are a Consumer we will collect additional Personal Data
                  from you, sometimes for our own purposes and other times on
                  behalf of an Organizer (see Section 16 below for more
                  information). Information you provide via
                  NecessaryDevil/Interface Infosoft solutions .P .Ltd Properties
                  or Applications: If you register for a paid event, you will
                  provide financial information (e.g., your credit card number
                  and expiration date, billing address, etc.) some of which may
                  constitute Personal Data. In addition, Organizers can set up
                  event registration pages to collect virtually any information
                  from Consumers in connection with registration for an
                  Organizer’s event listed on the Services. NecessaryDevil does
                  not control an Organizer’s registration process nor the
                  Personal Data that they collect. When you register for, or
                  otherwise provide information to NecessaryDevil in conjunction
                  with an Organizer event or activity, whether that information
                  is yours or a third party’s, in connection with a purchase,
                  registration, or transfer, that Organizer will receive and may
                  use the information you provide.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>Information we obtain from other sources:</strong>
                <Typography variant="body2" className={classes.greyText}>
                  We may also collect or receive Personal Data from third party
                  sources, such as Organizers, other Consumers, social media or
                  other third-party integrations, your credit card issuing bank,
                  our payment processing partners or other third parties.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>Information collected for specific reasons:</strong>
                <Typography variant="body2" className={classes.greyText}>
                  We collect & use the Personal Data we collect in a manner that
                  is consistent with this Privacy Policy, and applicable privacy
                  laws. We may use Personal Data as follows: • Specific reason:
                  If you provide Personal Data for a certain purpose, we may use
                  the Personal Data in connection with the purpose for which it
                  was provided. For instance, if you contact us by e-mail, we
                  will use the Personal Data you provide to answer your question
                  or resolve your problem and will respond to the email address
                  from which the contact came. • Access and use: If you provide
                  Personal Data in order to obtain access to or use of the
                  Services or any functionality thereof, we will use your
                  Personal Data to provide you with access to or use of the
                  Services or functionality and to analyze your use of such
                  Services or functionality. For instance, if you supply
                  Personal Data relating to your identity or qualifications to
                  use certain portions of the Services, we will use that
                  information to make a decision as to granting you access to
                  use such Services and to assess your ongoing qualification to
                  use such services. • Internal business purposes: We may use
                  your Personal Data for internal business purposes, including
                  without limitation, to help us improve the content and
                  functionality of the Services, to better understand our Users,
                  to improve the Services, to protect against, identify or
                  address wrongdoing, to enforce our Terms of Service, to manage
                  your account and provide you with customer service, and to
                  generally manage the Services and our businesses.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>
                  How you can access, update or delete your personal data?
                </strong>
                <Typography variant="body2" className={classes.greyText}>
                  You can request access to some of your Personal Data being
                  stored by us. You can also ask us to correct, update or delete
                  any inaccurate Personal Data that we process about them. If a
                  Consumer initiates a data deletion request,
                  NecessaryDevil/interface Infosoft Solutions. P. Ltd is
                  authorized to delete or anonymize Personal Data of the
                  requesting Consumer from the Services even if that means
                  removing its availability to the Organizer through the
                  Services. However, if you are a Consumer, you understand that
                  even if NecessaryDevil/interface Infosoft Solutions. P. Ltd
                  deletes or anonymizes your Personal Data upon your request or
                  pursuant to this Policy, your Personal Data may still be
                  available in the Organizer’s own databases if transmitted to
                  the Organizer prior to NecessaryDevil/interface Infosoft
                  Solutions. P. Ltd receiving or acting on any deletion or
                  anonymization activity. We will consider and respond to all
                  requests in accordance with applicable.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                <strong>How long we retain your personal data?</strong>
                <Typography variant="body2" className={classes.greyText}>
                  We may retain your Personal Data as long as you are registered
                  to use the Services. However, we may retain Personal Data for
                  an additional period as is permitted or required under
                  applicable laws. Even if we delete your Personal Data it may
                  persist on backup or archival media for an additional period
                  of time for legal, tax or regulatory reasons or for legitimate
                  and lawful business purpose.
                </Typography>
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                Any change we make in our privacy policy & cookie settings will
                be notified on this page & wherever necessary will be conveyed
                to you through e-mail.
              </Typography>
            </li>

            <li>
              <Typography
                variant="body2"
                className={classes.greyText}
                paragraph
              >
                By accepting NecessaryDevil/Interface Infosoft Solutions. P.
                Ltd’s privacy policy and terms, you also adhere to Google’s
                Privacy & Terms.
              </Typography>
            </li>
          </ol>

          {/* Section: App Privacy Policy */}
          <Box
            style={{
              marginTop: "16px",
              marginBottom: "16px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <Typography variant="h5" gutterBottom>
              App Privacy Policy
            </Typography>
          </Box>

          <Typography variant="body2" className={classes.greyText}>
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            We use Your Personal data to provide and improve the Service. By
            using the Service, You agree to the collection and use of
            information in accordance with this Privacy Policy. This Privacy
            Policy has been created with the help of the{" "}
            <a
              href="https://www.privacypolicies.com/privacy-policy-generator/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}
            >
              Privacy Policy Generator
            </a>
            .
          </Typography>

          {/* Section: Interpretation and Definitions */}
          <Box style={{ marginTop: "16px", marginBottom: "16px" }}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Interpretation and Definitions
            </Typography>
          </Box>

          {/* Subsection: Interpretation */}
          <Box style={{ marginBottom: "16px" }}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Interpretation
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              The words of which the initial letter is capitalized have meanings
              defined under the following conditions. The following definitions
              shall have the same meaning regardless of whether they appear in
              singular or in plural.
            </Typography>
          </Box>

          {/* Subsection: Definitions */}
          <Box style={{ marginBottom: "16px" }}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Definitions
            </Typography>

            <Typography variant="body2" paragraph className={classes.greyText}>
              For the purposes of this Privacy Policy:
            </Typography>

            <ul style={{ paddingLeft: "1.5rem", marginTop: 0 }}>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Account</strong> means a unique account created for
                  You to access our Service or parts of our Service.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Affiliate</strong> means an entity that controls, is
                  controlled by or is under common control with a party, where
                  "control" means ownership of 50% or more of the shares, equity
                  interest or other securities entitled to vote for election of
                  directors or other managing authority.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Application</strong> means the software program
                  provided by the Company downloaded by You on any electronic
                  device, named Necessary Devil.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Company</strong> (referred to as either "the Company",
                  "We", "Us" or "Our" in this Agreement) refers to Interface
                  Infosoft Solutions Pvt. Ltd, Plot 3, Aamchi Colony, NDA Pashan
                  Road, Bavdhan.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Country</strong> refers to: Maharashtra, India.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Device</strong> means any device that can access the
                  Service such as a computer, a cellphone or a digital tablet.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Personal Data</strong> is any information that relates
                  to an identified or identifiable individual.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Service</strong> refers to the Application.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Service Provider</strong> means any natural or legal
                  person who processes the data on behalf of the Company. It
                  refers to third-party companies or individuals employed by the
                  Company to facilitate the Service, to provide the Service on
                  behalf of the Company, to perform services related to the
                  Service or to assist the Company in analyzing how the Service
                  is used.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>Usage Data</strong> refers to data collected
                  automatically, either generated by the use of the Service or
                  from the Service infrastructure itself (for example, the
                  duration of a page visit).
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>You</strong> means the individual accessing or using
                  the Service, or the company, or other legal entity on behalf
                  of which such individual is accessing or using the Service, as
                  applicable.
                </Typography>
              </li>
            </ul>
          </Box>

          {/* Section: Collecting and Using Your Personal Data */}
          <Box
            style={{
              marginTop: "16px",
              marginBottom: "16px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <Typography variant="h4" gutterBottom>
              Collecting and Using Your Personal Data
            </Typography>
          </Box>

          {/* Subsection: Types of Data Collected */}
          <Box style={{ marginBottom: "16px" }}>
            <Typography variant="h5" gutterBottom>
              Types of Data Collected
            </Typography>

            {/* Personal Data */}
            <Typography variant="h6" gutterBottom>
              Personal Data
            </Typography>
            <Typography variant="body2" className={classes.greyText} paragraph>
              While using Our Service, We may ask You to provide Us with certain
              personally identifiable information that can be used to contact or
              identify You. Personally identifiable information may include, but
              is not limited to:
            </Typography>
            <ul style={{ paddingLeft: "1.5rem" }}>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  Email address
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  First name and last name
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  Phone number
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  Address, State, Province, ZIP/Postal code, City
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  Usage Data
                </Typography>
              </li>
            </ul>

            {/* Usage Data */}
            <Typography variant="h6" gutterBottom style={{ marginTop: "16px" }}>
              Usage Data
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              Usage Data is collected automatically when using the Service.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              Usage Data may include information such as Your Device's Internet
              Protocol address (e.g. IP address), browser type, browser version,
              the pages of our Service that You visit, the time and date of Your
              visit, the time spent on those pages, unique device identifiers
              and other diagnostic data.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              When You access the Service by or through a mobile device, We may
              collect certain information automatically, including, but not
              limited to, the type of mobile device You use, Your mobile device
              unique ID, the IP address of Your mobile device, Your mobile
              operating system, the type of mobile Internet browser You use,
              unique device identifiers and other diagnostic data.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              We may also collect information that Your browser sends whenever
              You visit our Service or when You access the Service by or through
              a mobile device.
            </Typography>

            {/* Info Collected While Using the Application */}
            <Typography
              variant="h6"
              gutterBottom
              style={{ marginTop: "16px", fontFamily: "Poppins, sans-serif" }}
            >
              Information Collected while Using the Application
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              While using Our Application, in order to provide features of Our
              Application, We may collect, with Your prior permission: Pictures
              and other information from your Device's camera and photo library
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              We use this information to provide features of Our Service, to
              improve and customize Our Service. The information may be uploaded
              to the Company's servers and/or a Service Provider's server or it
              may be simply stored on Your device.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              You can enable or disable access to this information at any time,
              through Your Device settings.
            </Typography>
          </Box>

          {/* Subsection: Use of Your Personal Data */}
          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h6" gutterBottom>
              Use of Your Personal Data
            </Typography>
            <Typography variant="body2" className={classes.greyText} paragraph>
              The Company may use Personal Data for the following purposes:
            </Typography>

            <ul style={{ paddingLeft: "1.5rem" }}>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>To provide and maintain our Service </strong>,
                  including to monitor the usage of our Service.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong> To manage Your Account:</strong> to manage Your
                  registration as a user of the Service. The Personal Data You
                  provide can give You access to different functionalities of
                  the Service that are available to You as a registered user.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>For performance of a contract</strong> the
                  development, compliance and undertaking of the purchase
                  contract for the products, items or services You have
                  purchased or of any other contract with Us through the
                  Service.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong> To contact You </strong> To contact You by email,
                  telephone calls, SMS, or other equivalent forms of electronic
                  communication, such as a mobile application's push
                  notifications regarding updates or informative communications
                  related to the functionalities, products or contracted
                  services, including the security updates, when necessary or
                  reasonable for their implementation.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong> To provide You </strong>with news, special offers and
                  general information about other goods, services and events
                  which we offer that are similar to those that you have already
                  purchased or enquired about unless You have opted not to
                  receive such information.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>To manage Your requests:</strong> To attend and manage
                  Your requests to Us.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>For business transfers:</strong> We may use Your
                  information to evaluate or conduct a merger, divestiture,
                  restructuring, reorganization, dissolution, or other sale or
                  transfer of some or all of Our assets, whether as a going
                  concern or as part of bankruptcy, liquidation, or similar
                  proceeding, in which Personal Data held by Us about our
                  Service users is among the assets transferred.
                </Typography>
              </li>

              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>For other purposes:</strong> We may use Your
                  information for other purposes, such as data analysis,
                  identifying usage trends, determining the effectiveness of our
                  promotional campaigns and to evaluate and improve our Service,
                  products, services, marketing and your experience. We may
                  share Your personal information in the following situations:
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>With Service Providers:</strong> For monitoring and
                  contacting purposes.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>For business transfers:</strong> During negotiation or
                  execution of company mergers/sales.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>With Affiliates:</strong> Our parent or sibling
                  companies under this Privacy Policy.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>With business partners:</strong> To offer you
                  products, services or promotions.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>With other users:</strong> When interacting in public
                  areas of the service.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" className={classes.greyText}>
                  <strong>With Your consent:</strong> For any other purpose you
                  explicitly approve.
                </Typography>
              </li>
            </ul>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Retention of Your Personal Data
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              The Company will retain Your Personal Data only for as long as is
              necessary for the purposes set out in this Privacy Policy. We will
              retain and use Your Personal Data to the extent necessary to
              comply with our legal obligations (for example, if we are required
              to retain your data to comply with applicable laws), resolve
              disputes, and enforce our legal agreements and policies.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              The Company will also retain Usage Data for internal analysis
              purposes. Usage Data is generally retained for a shorter period of
              time, except when this data is used to strengthen the security or
              to improve the functionality of Our Service, or We are legally
              obligated to retain this data for longer time periods.
            </Typography>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Transfer of Your Personal Data
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              Your information, including Personal Data, is processed at the
              Company's operating offices and in any other places where the
              parties involved in the processing are located. It means that this
              information may be transferred to — and maintained on — computers
              located outside of Your state, province, country or other
              governmental jurisdiction where the data protection laws may
              differ than those from Your jurisdiction. Your consent to this
              Privacy Policy followed by Your submission of such information
              represents Your agreement to that transfer.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              The Company will take all steps reasonably necessary to ensure
              that Your data is treated securely and in accordance with this
              Privacy Policy and no transfer of Your Personal Data will take
              place to an organization or a country unless there are adequate
              controls in place including the security of Your data and other
              personal information.
            </Typography>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Disclosure of Your Personal Data Business Transactions
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              If the Company is involved in a merger, acquisition or asset sale,
              Your Personal Data may be transferred. We will provide notice
              before Your Personal Data is transferred and becomes subject to a
              different Privacy Policy.
            </Typography>
          </Box>
          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Law enforcement
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              Under certain circumstances, the Company may be required to
              disclose Your Personal Data if required to do so by law or in
              response to valid requests by public authorities (e.g. a court or
              a government agency).
            </Typography>
          </Box>
          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Other legal requirements
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              The Company may disclose Your Personal Data in the good faith
              belief that such action is necessary to:
              <ul>
                <li>Comply with a legal obligation </li>
                <li>
                  Protect and defend the rights or property of the Company{" "}
                </li>
                <li>
                  Prevent or investigate possible wrongdoing in connection with
                  the Service
                </li>
                <li>
                  Protect the personal safety of Users of the Service or the
                  public
                </li>
                <li>Protect against legal liability</li>
              </ul>
            </Typography>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Children's Privacy
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              Our Service does not address anyone under the age of 13. We do not
              knowingly collect personally identifiable information from anyone
              under the age of 13. If You are a parent or guardian and You are
              aware that Your child has provided Us with Personal Data, please
              contact Us. If We become aware that We have collected Personal
              Data from anyone under the age of 13 without verification of
              parental consent, We take steps to remove that information from
              Our servers.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              If We need to rely on consent as a legal basis for processing Your
              information and Your country requires consent from a parent, We
              may require Your parent's consent before We collect and use that
              information.
            </Typography>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Links to Other Websites
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              Our Service may contain links to other websites that are not
              operated by Us. If You click on a third party link, You will be
              directed to that third party's site. We strongly advise You to
              review the Privacy Policy of every site You visit.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              We have no control over and assume no responsibility for the
              content, privacy policies or practices of any third party sites or
              services.
            </Typography>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Changes to this Privacy Policy
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              We may update Our Privacy Policy from time to time. We will notify
              You of any changes by posting the new Privacy Policy on this page.
              We will let You know via email and/or a prominent notice on Our
              Service, prior to the change becoming effective and update the
              "Last updated" date at the top of this Privacy Policy.
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              You are advised to review this Privacy Policy periodically for any
              changes. Changes to this Privacy Policy are effective when they
              are posted on this page.
            </Typography>
          </Box>

          <Box
            style={{ marginBottom: "16px", fontFamily: "Poppins, sans-serif" }}
          >
            <Typography variant="h5" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              If you have any questions about this Privacy Policy, You can
              contact us:
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              By email: necessarydevil@interfaceinfosoft.com
            </Typography>
            <Typography variant="body2" className={classes.greyText}>
              By visiting this page on our website:
              <a
                href="https://necessarydevil.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }}
              >
                https://necessarydevil.com
              </a>
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <ScrollTop />
    </>
  );
}
const styles = (theme) => ({
  greyText: {
    color: "#616161",
    fontFamily: "Poppins, sans-serif",
  },
});
export default compose(withStyles(styles), withRouter)(PrivacyPolicy);
